import styled from '@emotion/styled';
import { Icon, tokens, Tooltip } from '@hotjar/hotsauce';
import { useTranslation } from '@hotjar/translations';

const StyledButton = styled.button`
  background: ${tokens.color.neutral_200};
  border: 0;
  border-radius: ${tokens.radius.m};
  padding: 0;

  &:focus {
    ${tokens.focus()};
  }
  &:active {
    ${tokens.elevation(-1)};
  }
`;

const NoScreenshot = styled.span`
  ${tokens.text('subtitle3')};
  color: ${tokens.color.text_light};
  white-space: nowrap;
  display: flex;
  height: 67px;
  width: 148px;
  justify-content: center;
  align-items: center;
`;

const StyledIcon = styled(Icon)`
  margin-right: ${tokens.spacer.x1};
`;

const StyledImage = styled.img`
  max-width: 148px;
  max-height: 148px;

  box-shadow: 0 2px 5px 0 rgb(0 0 0 / 10%);
  border: 1px solid #ddd;
  box-sizing: border-box;
  border-radius: 4px;
}
`;

const TooltipWrapper = styled.div`
  max-width: 148px;
  min-height: 67px;
  text-align: center;
`;

export function Screenshot({
  thumbnailUrl,
  onClick,
  description,
}: {
  thumbnailUrl: string | null;
  onClick: () => void;
  description: string;
}): JSX.Element {
  const { t } = useTranslation('feedback', { keyPrefix: 'feedback-responses.list' });
  return (
    <Tooltip text={description}>
      <TooltipWrapper>
        <StyledButton onClick={onClick} aria-label={description}>
          {thumbnailUrl && <StyledImage alt={t('feedback-screenshot')} src={thumbnailUrl} />}
          {!thumbnailUrl && (
            <NoScreenshot>
              <StyledIcon icon="image" size="m" color="text_default" inline />
              {t('no-screenshot')}
            </NoScreenshot>
          )}
        </StyledButton>
      </TooltipWrapper>
    </Tooltip>
  );
}
